/**
 * Device type enum for filtering
 */
export enum DeviceType {
  ChassisServer = 'CHASSIS_SERVER',
  Daas = 'DAAS',
  Database = 'DATABASE',
  FddiNetwork = 'FDDI_NETWORK',
  Msd = 'MSD',
  Netgear = 'NETGEAR',
  PhysicalServer = 'PHYSICAL_SERVER',
  Unknown = 'UNKNOWN',
  VirtualMachine = 'VIRTUAL_MACHINE',
}

/**
 * File type enum for export format
 */
export enum FILETYPE {
  CSV = 'csv',
  EXCEL = 'excel',
}

/**
 * Hierarchy level display labels
 */
export const HIERARCHY_LEVEL_LABELS = {
  DIRECT_REPORTS: 'Direct Reports Only',
  FULL_REPORTING_HIERARCHY: 'Full Reporting Hierarchy',
} as const;
